import isEmpty from 'lodash.isempty';
import { Space } from 'antd';

export const arrayToColumn = (data, field) => {
  if (!Array.isArray(data) || isEmpty(data) || !data) {
    return null;
  }

  const getDataToDisplay = () => (field ? data.map(item => item[field]) : data.map(item => item));

  return <Space direction='vertical'>{getDataToDisplay()}</Space>;
};
